import { CeleryStatusesMapIdType } from "@shared/constants";
import CeleryJobRepository from "./CeleryJobRepository";

export type GetTaskFromJobIdReturnType<T = string> = {
  id: string;
  data: T;
  state: CeleryStatusesMapIdType;
};

/**
 * A type representing an endpoint that uses a queue to perform it's tasks.
 *
 * When an endpoint produces a task for the queue, it responds with a `job_id` which
 * allows for us to poll the backend using another endpoint to get the status of the task.
 */
export type TaskedEndpointResponse = {
  job_id: "string";
};

type JobTaskError = {
  id: string;
  data: { detail: string };
  state: CeleryStatusesMapIdType;
};

export function isJobTaskError(object: unknown): object is JobTaskError {
  if (typeof object !== "object" || object === null) {
    return false;
  }

  const { id, data, state } = object as JobTaskError;

  if (typeof data !== "object") {
    return false;
  }

  const { detail } = data;

  return detail !== undefined && id !== undefined && state !== undefined;
}

export const getTaskFromJobId = async <T = string>(
  taskId: string
): Promise<GetTaskFromJobIdReturnType<T>> => {
  const data = await new CeleryJobRepository().retrieve(taskId);

  return {
    id: data.id,
    data: data.data as T,
    state: data.state,
  };
};
